export const PARO_TIPS = [
  {
    id: 0,
    text:
      '"We want to empower you to become your own boss, taking back control of your how you work, when you  work, and why you work. Registration begins by  building your profile for internal review. Make sure the information you provide is detailed and complete to ensure proper review before vetting."',
    flops: {
      image: 'kelly-hansen.png',
      name: 'Kelly Hansen',
      title: 'Director of Marketplace Operations',
    },
    label: 'You are building a strong foundation, great work!',
    value: 10,
  },
  {
    id: 1,
    text:
      '"Don’t worry, the primary service line you choose will not restrict you from other opportunities in other service lines! Your primary service line helps us get a baseline understanding of the type of work you are most qualified for. Note that the service line you elect will dictate your vetting experience as well."',
    flops: {
      image: 'jade-simon.png',
      name: 'Jade Simon',
      title: 'Senior Analyst, Marketplace Operations',
    },
    label: 'Now we know where your expertise is, thanks!',
    value: 20,
  },
  {
    id: 2,
    text:
      '"Looking for a platform to cut your business development time in half and handle all of your invoicing? You came to the right place! Paro handles these major freelancing pain points and more!"',
    flops: {
      image: 'alexander-koh.png',
      name: 'Alexander Koh',
      title: 'Senior Analyst, Marketplace Operations',
    },
    label: 'Your education is important for building trust with clients! Good work!',
    value: 30,
  },
  {
    id: 3,
    text:
      '"Did you know freelancers with at least 5 bullets per work experience were 5x more likely to get matched to relevant projects? Make sure you outline your accounting/finance experience in a way similar to a resume to assure the greatest probability of being matched in the future."',
    flops: {
      image: 'kelly-hansen.png',
      name: 'Kelly Hansen',
      title: 'Director of Marketplace Operations',
    },
    label: 'Your profile is getting stronger!',
    value: 40,
  },
  {
    id: 4,
    text:
      '"Never done project based work before? Don’t fret! We’ve found freelancers to be successful when they can pull out specific projects from their more traditional employment. Did you implement a new process? Were you responsible for a monthly task? Use those key contributor moments to highlight how you stand out from others!"',
    flops: {
      image: 'jade-simon.png',
      name: 'Jade Simon',
      title: 'Senior Analyst, Marketplace Operations',
    },
    label: 'Halfway there! Keep going!',
    value: 50,
  },
  {
    id: 5,
    text:
      '"Make sure your most relevant certifications are front and center. Are you a certified nurse practitioner (CNP) as well as a certified public accountant (CPA)? First of all, very cool! Secondly, make sure you save your CNP for your bio and highlight your CPA here!"',
    flops: {
      image: 'alexander-koh.png',
      name: 'Alexander Koh',
      title: 'Senior Analyst, Marketplace Operations',
    },
    label: 'WOW! Very impressive!',
    value: 75,
  },
  {
    id: 6,
    text:
      '"Your bandwidth is a variable that is taken into consideration when matching you to opportunities. Have a job, side hustle, or your own clients that you work with? Let us know how much of your bandwidth you’d like to dedicate to clients you acquire through Paro."',
    flops: {
      image: 'kelly-hansen.png',
      name: 'Kelly Hansen',
      title: 'Director of Marketplace Operations',
    },
    label: 'Thank you for telling us how you like to work!',
    value: 80,
  },
  {
    id: 7,
    text:
      '"This is your time to shine! Take this opportunity to create a 30-second elevator pitch to differentiate yourself from your peers. Be sure to highlight your professional journey and show a bit of your personality. The most effective bios have been written in the third-person. Remember, future clients will read this to help evaluate their decision in working with you."',
    flops: {
      image: 'jade-simon.png',
      name: 'Jade Simon',
      title: 'Senior Analyst, Marketplace Operations',
    },
    label: 'You are shining now!',
    value: 90,
  },
  {
    id: 8,
    text:
      '"Please make sure all the information on your profile is accurate before our team reviews your registration. Your profile is the single source of truth when matching you to opportunities and assessing your fit for the Paro network. You will be unable to edit or change your profile upon submission, so be sure that it’s void of any errors!"',
    flops: {
      image: 'kelly-hansen.png',
      name: 'Kelly Hansen',
      title: 'Director of Marketplace Operations',
    },
    label: 'Great work! This profile looks FANTASTIC!',
    value: 100,
  },
]
